import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { ProductDisplay } from '../../pages';
import { inventoryStore } from '../../stores';
import { InventoryController } from '../../controllers';
import { useParams } from 'react-router-dom';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { toJS } from "mobx"

const ProductDisplayContainer = () => {
  const [stockData, setStockData] = useState(toJS(inventoryStore.selectedStock) || {});
  const { productCode } = useParams()
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true)
  const [Img1, setImg1] = useState("")
  const [Img2, setImg2] = useState("")
  const [Img3, setImg3] = useState("")
  const [mainImage, setMainImage] = useState("")
  const [biz, setBiz] = useState({})

  const navigate = useNavigate()

  useEffect(()=>{
  const getPageContent = async () => {
    setLoading(true);
    const {status,  data, errorMessage} =  await InventoryController.checkProduct(productCode);
    if (status === constant.Success) {
            setProduct(data);
            setImg1(data?.imageUrls[0]);
            setImg2(data?.imageUrls[1]);
            setImg3(data?.imageUrls[2]);
            setMainImage(data?.imageUrls[0]);
            setBiz(data?.business)
            inventoryStore.setSelectedStock(data?.stocks[0] || {})
            setLoading(false);
            return;
          }
          MimaToastUtil.error({
            message: errorMessage,
          })
  }
  getPageContent();

    window.localStorage.removeItem('stock');
}, [])



  const validationSchema = () => {
		return yup.object({
			quantity: yup.number()
      .test({
        test(value, ctx) {
          if ((inventoryStore.selectedStock?.quantity === undefined)) {
            return ctx.createError({ message: 'Out of stock Or Kindly Select a Variation' })
          }
          return true
        }
      })
      .min(1, 'Quantity cannot be less than 1')
      .max(inventoryStore.selectedStock?.quantity, `Only ${inventoryStore.selectedStock?.quantity} quantity is available`).required('Quantity is required')
		});
	};



  const onStockClick = stock => {
		if (stock?._id !== inventoryStore?._id) {
			inventoryStore.setSelectedStock(stock)
		}
	};


  const onSubmit = (value) => {
    setLoading(true);
    const checkOutInfo = {...inventoryStore.selectedStock, ...value, name: product?.name};
    localStorage.setItem('stock', JSON.stringify(checkOutInfo));
    navigate(constant.Routes.ProductCheckOut)
    setLoading(false)
  }

  return (
    <ProductDisplay
      product={product}
      stockData={stockData}
      onStockClick={onStockClick}
      validationSchema={validationSchema}
      loading={loading}
      onSubmit={onSubmit}
      Img1={Img1}
      Img2={Img2}
      Img3={Img3}
      mainImage={mainImage}
      setMainImage={setMainImage}
      biz={biz}
    />
  )
}

export default observer(ProductDisplayContainer)